import { render, staticRenderFns } from "./WebDevelopmentMain.vue?vue&type=template&id=68c4ffa2&"
import script from "./WebDevelopmentMain.vue?vue&type=script&lang=js&"
export * from "./WebDevelopmentMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports